import React, { useEffect, useRef, useState } from 'react'

import {
  Grid,
  Card,
  Form,
  Input,
  Picker,
  Span,
  SimpleCollapse,
  RadioGroup,
  SimpleCard,
  Row,
  CheckBox,
  Button,
  InputMask,
  AutoCompleteInput
} from 'components'
import GerenciaFields from 'components/GerenciaFields'
import { MagnifyingGlassIcon } from 'components/Icons'
import { ReportsRow, buildSetSize, getItemSize } from 'components/ReportsRow'
import {
  useCheckListWithPagination,
  useDebounce,
  useException,
  useLoading,
  useModal,
  useWindowResize,
  usePersistForm,
  useAuth
} from 'hooks'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { VariableSizeList as List } from 'react-window'
import { IResponseTypes } from 'services/core/genericEntityGST'
import { IKeyValue } from 'services/database/reportsDatabase'
import {
  EnumDiasPendentes,
  IItensSegurancaEntity,
  IRelatorioItensPendentesRequest,
  ItensPendentesServices,
  itensSegurancaServices
} from 'services/GST/ItensPendentes'
import { UserCsnService } from 'services/Supplier/Users'
import { SPACING } from 'utils'

import { IForm } from './types'
import UnidadeGestoraFields, {
  IOnChangeUnidadeGestora
} from '../../../../components/UnidadeGestoraFields'

const DATE_NOW = new Date()

const DEFAULT_FORM: IForm = {
  cdDiasPendentes: 2,
  centro: '',
  contraparte: '',
  contraparteId: undefined,
  contrato: '',
  empresa: '',
  fornecedor: '',
  itemSeguranca: '',
  matriculaContraparte: '',
  matriculaSubstituto: '',
  mesAno: '',
  periodoFim: DATE_NOW,
  periodoInicio: null,
  quantidadeDias: '',
  status: '',
  substituto: '',
  substitutoId: undefined,
  tipoLayout: ''
}

export interface IAutoComplete {
  matriculaContraparte: IKeyValue<string>[]
  matriculaSubstituto: IKeyValue<string>[]
  nomeContraparte: IKeyValue<string>[]
  nomeSubstituto: IKeyValue<string>[]
}

interface IGetFillCardsProps {
  event?: any
  isPrint?: boolean
  isClear?: boolean
}

interface IList {
  checked: boolean
  label: string
  itemId: number
}

const PendingItems: React.FC = () => {
  const {
    control,
    watch,
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = useForm<IForm>({
    defaultValues: DEFAULT_FORM
  })

  usePersistForm('report-pending-items-form', {
    setValue: setValue,
    watch: watch
  })

  const { setLoading } = useLoading()
  const { getException, createCustomException } = useException()
  const { showModal } = useModal()
  const { user } = useAuth()

  const [selectedMatriculaContraparte, setSelectedMatriculaContraparte] =
    useState('')
  const [selectedContraparte, setSelectedContraparte] = useState('')

  const [selectedMatriculaSubstituto, setSelectedMatriculaSubstituto] =
    useState('')
  const [selectedSubstituto, setSelectedSubstituto] = useState('')

  const [firstAcess, setFirstAcess] = useState<boolean>(true)
  const [acionouLimpar, setAcionouLimpar] = useState<boolean>(false)
  const [unidadeGestoraID, setUnidadeGestoraID] =
    useState<IOnChangeUnidadeGestora>({} as IOnChangeUnidadeGestora)
  const childRef: any = useRef()

  const [clickCheckAllContraparte, setClickCheckAllContraparte] =
    useState<boolean>(false)
  const [clickCheckAllSubstituto, setClickCheckAllSubstituto] =
    useState<boolean>(false)
  const [clickCheckAllEmpresa, setClickCheckAllEmpresa] =
    useState<boolean>(false)
  const [clickCheckAllCentro, setClickCheckAllCentro] = useState<boolean>(false)
  const [clickCheckAllFornecedor, setClickCheckAllFornecedor] =
    useState<boolean>(false)
  const [clickCheckAllSubContrato, setClickCheckAllSubContrato] =
    useState<boolean>(false)
  const [clickCheckAllSubFornecedor, setClickCheckAllSubFornecedor] =
    useState<boolean>(false)
  const [clickCheckAllTipoDocumento, setClickCheckAllTipoDocumento] =
    useState<boolean>(false)

  const [autoComplete, setAutoComplete] = useState<IAutoComplete>({
    matriculaContraparte: [],
    matriculaSubstituto: [],
    nomeContraparte: [],
    nomeSubstituto: []
  })

  const [empresa, setEmpresa] = useState('')
  const [centro, setCentro] = useState('')
  const [fornecedor, setFornecedor] = useState('')
  const [contrato, setContrato] = useState('')

  // Controle das listas e seus CheckBoxes
  // Contraparte
  const {
    data: contraparteList,
    setData: setContraparteList,
    selectedItems: selectedItemsContraparte,
    handleSelectItem: handleSelectItemContraparte,
    handleToWaive: handleToWaiveContraparte,
    handleCheckAll: handleCheckAllContraparte,
    isAllChecked: isAllContraparteChecked,
    handleClearSelectedItems: handleClearSelectedItemsContraparte
  } = useCheckListWithPagination<IList>({
    keyName: 'itemId',
    onSelectItem: () => ''
  })

  // Substituto
  const {
    data: substitutoList,
    selectedItems: selectedItemsSubstituto,
    setData: setSubstitutoList,
    handleSelectItem: handleSelectItemSubstituto,
    handleToWaive: handleToWaiveSubstituto,
    handleCheckAll: handleCheckAllSubstituto,
    isAllChecked: isAllSubstitutoChecked,
    handleClearSelectedItems: handleClearSelectedItemsSubstituto
  } = useCheckListWithPagination<IList>({
    keyName: 'itemId',
    onSelectItem: () => ''
  })

  // Empresa
  const {
    data: empresaList,
    setData: setEmpresaList,
    selectedItems: selectedItemsEmpresa,
    handleSelectItem: handleSelectItemEmpresa,
    handleToWaive: handleToWaiveEmpresa,
    handleCheckAll: handleCheckAllEmpresa,
    isAllChecked: isAllEmpresaChecked,
    handleClearSelectedItems: handleClearSelectedItemsEmpresa
  } = useCheckListWithPagination<IList>({
    keyName: 'itemId',
    onSelectItem: () => ''
  })

  // Centro
  const {
    data: centroList,
    setData: setCentroList,
    selectedItems: selectedItemsCentro,
    handleSelectItem: handleSelectItemCentro,
    handleToWaive: handleToWaiveCentro,
    handleCheckAll: handleCheckAllCentro,
    isAllChecked: isAllCentroChecked,
    handleClearSelectedItems: handleClearSelectedItemsCentro
  } = useCheckListWithPagination<IList>({
    keyName: 'itemId',
    onSelectItem: () => ''
  })

  // Fornecedor
  const {
    data: fornecedorList,
    setData: setFornecedorList,
    selectedItems: selectedItemsFornecedor,
    handleSelectItem: handleSelectItemFornecedor,
    handleToWaive: handleToWaiveFornecedor,
    handleCheckAll: handleCheckAllFornecedor,
    isAllChecked: isAllFornecedorChecked,
    handleClearSelectedItems: handleClearSelectedItemsFornecedor
  } = useCheckListWithPagination<IList>({
    keyName: 'itemId',
    onSelectItem: () => ''
  })

  // subContratadasContrato
  const {
    data: subContratadasContratoList,
    setData: setSubContratadasContratoList,
    selectedItems: selectedItemsSubContratadasContrato,
    handleSelectItem: handleSelectItemSubContratadasContrato,
    handleToWaive: handleToWaiveSubContratadasContrato,
    handleCheckAll: handleCheckAllSubContratadasContrato,
    isAllChecked: isAllSubContratadasContratoChecked,
    handleClearSelectedItems: handleClearSelectedItemssubContrato
  } = useCheckListWithPagination<IList>({
    keyName: 'itemId',
    onSelectItem: () => ''
  })

  // subContratadasFornecedor
  const {
    data: subContratadasFornecedorList,
    setData: setSubContratadasFornecedorList,
    selectedItems: selectedItemsSubContratadasFornecedor,
    handleSelectItem: handleSelectItemSubContratadasFornecedor,
    handleToWaive: handleToWaiveSubContratadasFornecedor,
    handleCheckAll: handleCheckAllSubContratadasFornecedor,
    isAllChecked: isAllSubContratadasFornecedorChecked,
    handleClearSelectedItems: handleClearSelectedItemssubFornecedor
  } = useCheckListWithPagination<IList>({
    keyName: 'itemId',
    onSelectItem: () => ''
  })

  // ItemSeguranca
  const {
    data: itemSegurancaList,
    setData: setItemSegurancaList,
    handleSelectItem: handleSelectItemItemSeguranca,
    handleToWaive: handleToWaiveItemSeguranca,
    handleCheckAll: handleCheckAllItemSeguranca,
    isAllChecked: isAllItemSegurancaChecked,
    handleClearSelectedItems: handleClearSelectedItemsItemSeguranca
  } = useCheckListWithPagination<IItensSegurancaEntity>({
    keyName: 'idItemSeguranca',
    onSelectItem: () => ''
  })

  const handleClear = () => {
    setAcionouLimpar(true)
    reset()
    setContraparteList([])
    setSubstitutoList([])
    setEmpresaList([])
    setCentroList([])
    setFornecedorList([])
    setSubContratadasContratoList([])
    setSubContratadasFornecedorList([])

    handleClearSelectedItemsContraparte()
    handleClearSelectedItemsSubstituto()
    handleClearSelectedItemsEmpresa()
    handleClearSelectedItemsCentro()
    handleClearSelectedItemsFornecedor()
    handleClearSelectedItemssubContrato()
    handleClearSelectedItemssubFornecedor()
    handleClearSelectedItemsItemSeguranca()

    setClickCheckAllContraparte(false)
    setClickCheckAllSubstituto(false)
    setClickCheckAllEmpresa(false)
    setClickCheckAllCentro(false)
    setClickCheckAllFornecedor(false)
    setClickCheckAllSubContrato(false)
    setClickCheckAllSubFornecedor(false)
    setClickCheckAllTipoDocumento(false)

    setSelectedMatriculaContraparte('')
    setSelectedContraparte('')
    setSelectedMatriculaSubstituto('')
    setSelectedSubstituto('')
    setEmpresa('')
    setCentro('')
    setFornecedor('')
    setContrato('')

    setAutoComplete({
      matriculaContraparte: [],
      matriculaSubstituto: [],
      nomeContraparte: [],
      nomeSubstituto: []
    })

    handleGetFillCardsAndPrint({
      isClear: true
    })
  }

  const filterAndMapList = (objList: IList[]): number[] => {
    return objList
      ?.filter((item) => item?.checked === true)
      ?.map((itemFiltered) => itemFiltered?.itemId)
  }

  const filterAndMapListItenSeguranca = (
    objList: IItensSegurancaEntity[]
  ): number[] => {
    return objList
      ?.filter((item) => item?.checked === true)
      ?.map((itemFiltered) => itemFiltered?.idItemSeguranca)
  }

  const handleSearchUsuario = (event) => {
    const valueWithoutLike = event.target.value.replaceAll('%', '')
    if (valueWithoutLike === '')
      return setAutoComplete((prevState) => ({
        ...prevState,
        nomeContraparte: [],
        nomeSubstituto: []
      }))
    const isUsingLike = event?.target?.value?.includes('%')
    const valorTratado = isUsingLike
      ? event.target.value.replaceAll('%', '%25')
      : event.target.value
    setLoading('loading')
    UserCsnService()
      .autoComplete({ cdMatricula: '', nmUsuario: valorTratado })
      .then((response) => {
        const usuarios = response.data.entity.map((usuario) => ({
          label: usuario.nmUsuario,
          value: usuario
        }))

        setAutoComplete((prevState) => ({
          ...prevState,
          [event.target.name]: usuarios
        }))
        setLoading('idle')
      })
      .catch((_) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os dados do usuário',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const handleSearchMatricula = (event) => {
    setLoading('loading')
    UserCsnService()
      .autoComplete({ cdMatricula: event.target.value, nmUsuario: '' })
      .then((response) => {
        const matriculas = response.data.entity.map((matricula) => ({
          label: matricula.cdMatricula,
          value: matricula
        }))
        setAutoComplete((prevState) => ({
          ...prevState,
          [event.target.name]: matriculas
        }))
        setLoading('idle')
      })
      .catch((_) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os dados da matrícula',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const handleGetFillCardsAndPrint = ({
    event,
    isPrint,
    isClear
  }: IGetFillCardsProps) => {
    setLoading('loading')
    const objectToSave: IRelatorioItensPendentesRequest = {
      IdUsuario: user.IdUsuario,
      checkAll: {
        centro: {
          isCheckAll: clickCheckAllCentro,
          itensCheckados: isClear
            ? []
            : !clickCheckAllCentro
            ? filterAndMapList(centroList)
            : centroList.every((centro) => centro.checked === true)
            ? []
            : centroList
                ?.filter((item) => item?.checked === false)
                ?.map((itemFiltered) => itemFiltered?.itemId),
          txPesquisa: isClear ? '' : centro
        },
        contraparte: {
          isCheckAll: clickCheckAllContraparte,
          itensCheckados: isClear
            ? []
            : !clickCheckAllContraparte
            ? filterAndMapList(contraparteList)
            : contraparteList.every(
                (contraparte) => contraparte.checked === true
              )
            ? []
            : contraparteList
                ?.filter((item) => item?.checked === false)
                ?.map((itemFiltered) => itemFiltered?.itemId),
          txPesquisa: isClear
            ? ''
            : event?.target?.name === 'Contraparte' && event?.target?.value
            ? event?.target?.value
            : selectedContraparte
        },
        empresa: {
          isCheckAll: clickCheckAllEmpresa,
          itensCheckados: isClear
            ? []
            : !clickCheckAllEmpresa
            ? filterAndMapList(empresaList)
            : empresaList.every((empresa) => empresa.checked === true)
            ? []
            : empresaList
                ?.filter((item) => item?.checked === false)
                ?.map((itemFiltered) => itemFiltered?.itemId),
          txPesquisa: isClear ? '' : empresa
        },
        fornecedor: {
          isCheckAll: clickCheckAllFornecedor,
          itensCheckados: isClear
            ? []
            : !clickCheckAllFornecedor
            ? filterAndMapList(fornecedorList)
            : fornecedorList.every((fornecedor) => fornecedor.checked === true)
            ? []
            : fornecedorList
                ?.filter((item) => item?.checked === false)
                ?.map((itemFiltered) => itemFiltered?.itemId),
          txPesquisa: isClear ? '' : fornecedor
        },
        subcontratadaContrato: {
          isCheckAll: clickCheckAllSubContrato,
          itensCheckados: isClear
            ? []
            : !clickCheckAllSubContrato
            ? filterAndMapList(subContratadasContratoList)
            : subContratadasContratoList.every(
                (subContrato) => subContrato.checked === true
              )
            ? []
            : subContratadasContratoList
                ?.filter((item) => item?.checked === false)
                ?.map((itemFiltered) => itemFiltered?.itemId),
          txPesquisa: isClear ? '' : contrato
        },
        substituto: {
          isCheckAll: clickCheckAllSubstituto,
          itensCheckados: isClear
            ? []
            : !clickCheckAllSubstituto
            ? filterAndMapList(substitutoList)
            : substitutoList.every((substituto) => substituto.checked === true)
            ? []
            : substitutoList
                ?.filter((item) => item?.checked === false)
                ?.map((itemFiltered) => itemFiltered?.itemId),
          txPesquisa: isClear
            ? ''
            : event?.target?.name === 'Substituto' && event?.target?.value
            ? event?.target?.value
            : selectedSubstituto
        }
      },
      contraparteId: watch('contraparteId'),
      enumDiasPendentes: watch('cdDiasPendentes'),
      idsItemSeguranca: isPrint
        ? filterAndMapListItenSeguranca(itemSegurancaList)
        : undefined,
      idsSubcontratadasFornecedor: isClear
        ? []
        : !clickCheckAllSubFornecedor
        ? filterAndMapList(subContratadasFornecedorList)
        : subContratadasFornecedorList.every(
            (subFornecedor) => subFornecedor.checked === true
          )
        ? []
        : subContratadasFornecedorList
            ?.filter((item) => item?.checked === false)
            ?.map((itemFiltered) => itemFiltered?.itemId),
      periodoFim: moment(watch('periodoFim')).isValid()
        ? new Date(watch('periodoFim')).toISOString()
        : null,
      periodoInicio: moment(watch('periodoInicio')).isValid()
        ? new Date(watch('periodoInicio')).toISOString()
        : null,
      qtdDias: parseInt(watch('quantidadeDias')) || undefined,
      substitutoId: watch('substitutoId') || undefined,
      tipoDocumentoIds: !isPrint
        ? filterAndMapListItenSeguranca(itemSegurancaList)
        : undefined,
      unidadeGestoraId: unidadeGestoraID.Gerencia
        ? unidadeGestoraID.Gerencia
        : unidadeGestoraID.GerenciaGeral
        ? unidadeGestoraID.GerenciaGeral
        : null
    }
    if (!isPrint) {
      ItensPendentesServices()
        .getFillCardsByFilterAndChecks(objectToSave)
        .then((response) => {
          if (
            response?.status !== 200 ||
            response?.data?.tipo === IResponseTypes['alert']
          ) {
            const { tipo, detalhe, mensagem } = response?.data

            createCustomException({
              detalhe,
              message:
                detalhe || mensagem || 'Ocorreu um erro ao fazer a requisição',
              tipo: IResponseTypes[tipo]
            })
          }

          setContraparteList(response.data?.entity?.contraparte)
          setSubstitutoList(response.data?.entity?.substituto)
          setEmpresaList(response.data?.entity?.empresa)
          setCentroList(response.data?.entity?.centro)
          setFornecedorList(response.data?.entity?.fornecedor)
          setSubContratadasContratoList(
            response.data?.entity?.subcontratadaContrato
          )
          setSubContratadasFornecedorList(
            response.data?.entity?.subcontratadaFornecedor
          )

          setLoading('idle')
        })
        .catch((e: Error) => {
          const error = getException(e)

          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message: error.message,
            txtButtonConfirm: 'OK',
            type: error.tipo || 'error'
          })
        })
    } else {
      ItensPendentesServices()
        .getExcelItensPendentesReport(objectToSave)
        .then((response) => {
          if (
            response?.status !== 200 ||
            response?.data?.tipo === IResponseTypes['alert']
          ) {
            const { tipo, detalhe, mensagem } = response?.data

            createCustomException({
              detalhe,
              message:
                detalhe || mensagem || 'Ocorreu um erro ao fazer a requisição',
              tipo: IResponseTypes[tipo]
            })
          }

          if (response?.data?.entity === 'Relatório enviado por e-mail.') {
            showModal({
              type: 'success',
              hideButtonCancel: true,
              message: response?.data?.entity
            })
            setLoading('idle')

            return
          }

          const url =
            'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
            response.data?.entity
          const downloadLink = document.createElement('a')
          downloadLink.href = url
          downloadLink.download = 'relatorio-itens-pendentes.xlsx'
          document.body.appendChild(downloadLink)
          downloadLink.click()
          document.body.removeChild(downloadLink)
          setLoading('idle')
        })
        .catch((e: Error) => {
          const error = getException(e)
          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message: error.message,
            txtButtonConfirm: 'OK',
            type: error.tipo || 'error'
          })
        })
    }
  }

  const handleGetAllItensSeguranca = () => {
    setLoading('loading')
    itensSegurancaServices()
      .getAllItensSeguranca()
      .then((response) => {
        if (
          response?.status !== 200 ||
          response?.data?.tipo === IResponseTypes['alert']
        ) {
          const { tipo, detalhe, mensagem } = response?.data

          createCustomException({
            detalhe,
            message:
              detalhe || mensagem || 'Ocorreu um erro ao fazer a requisição',
            tipo: IResponseTypes[tipo]
          })
        }

        setItemSegurancaList(response.data?.entity)
        setLoading('idle')
      })
      .catch((e: Error) => {
        const error = getException(e)
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error.message,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error'
        })
      })
  }

  // Configurações para React-window.
  const contraparteSizeMap = useRef({})
  const contraparteListRef = useRef(null)
  const contraparteSetSize = buildSetSize(
    contraparteSizeMap,
    contraparteListRef
  )

  const substitutoSizeMap = useRef({})
  const substitutoListRef = useRef(null)
  const substitutoSetSize = buildSetSize(substitutoSizeMap, substitutoListRef)

  const empresaSizeMap = useRef({})
  const empresaListRef = useRef(null)
  const empresaSetSize = buildSetSize(empresaSizeMap, empresaListRef)

  const centroSizeMap = useRef({})
  const centroListRef = useRef(null)
  const centroSetSize = buildSetSize(centroSizeMap, centroListRef)

  const fornecedorSizeMap = useRef({})
  const fornecedorListRef = useRef(null)
  const fornecedorSetSize = buildSetSize(fornecedorSizeMap, fornecedorListRef)

  const subContratadasContratoSizeMap = useRef({})
  const subContratadasContratoListRef = useRef(null)
  const subContratadasContratoSetSize = buildSetSize(
    subContratadasContratoSizeMap,
    subContratadasContratoListRef
  )

  const subContratadasFornecedorSizeMap = useRef({})
  const subContratadasFornecedorListRef = useRef(null)
  const subContratadasFornecedorSetSize = buildSetSize(
    subContratadasFornecedorSizeMap,
    subContratadasFornecedorListRef
  )

  const itemSegurancaSizeMap = useRef({})
  const itemSegurancaListRef = useRef(null)
  const itemSegurancaSetSize = buildSetSize(
    itemSegurancaSizeMap,
    itemSegurancaListRef
  )

  const [windowWidth] = useWindowResize()

  useEffect(() => {
    !firstAcess && !acionouLimpar && handleGetFillCardsAndPrint({})
    setAcionouLimpar(false)
  }, [
    watch('cdDiasPendentes'),
    watch('gerencia'),
    watch('gerenciaGeral'),
    selectedMatriculaContraparte,
    selectedMatriculaSubstituto,
    selectedContraparte,
    selectedSubstituto,
    // Verifica se um dos arrays de checkeds foi alterado
    selectedItemsContraparte,
    selectedItemsSubstituto,
    selectedItemsCentro,
    selectedItemsEmpresa,
    selectedItemsFornecedor,
    selectedItemsSubContratadasContrato,
    selectedItemsSubContratadasFornecedor,
    unidadeGestoraID
  ])

  useEffect(() => {
    !firstAcess &&
      !acionouLimpar &&
      setTimeout(() => handleGetFillCardsAndPrint({}), 500)
    firstAcess && handleGetAllItensSeguranca()
    setAcionouLimpar(false)
    if (firstAcess) {
      setContraparteList([])
      setSubstitutoList([])
      setEmpresaList([])
      setCentroList([])
      setFornecedorList([])
      setSubContratadasContratoList([])
      setSubContratadasFornecedorList([])

      setFirstAcess(false)
      handleGetFillCardsAndPrint({})
    }
  }, [watch('quantidadeDias'), watch('periodoInicio'), watch('periodoFim')])

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        marginTop={SPACING.spacing50}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        borderRadius={`0px 10px 0px 0px`}
      >
        <Form
          onSubmit={null}
          marginLeft={SPACING.spacing20}
          marginRight={SPACING.spacing20}
          marginBottom={SPACING.spacing10}
        >
          <Grid
            gridCols="2.3fr 1fr 3fr 1.5fr 0.0fr 1.5fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
          >
            <RadioGroup
              row
              label="Dias Pendentes"
              listOptions={[
                { label: EnumDiasPendentes[0], value: EnumDiasPendentes.Maior },
                { label: EnumDiasPendentes[1], value: EnumDiasPendentes.Menor },
                { label: EnumDiasPendentes[2], value: EnumDiasPendentes.Todos }
              ]}
              value={watch('cdDiasPendentes')}
              onChange={(e) => {
                setValue('cdDiasPendentes', parseInt(e.target.value))
              }}
            />
            <InputMask
              control={control}
              errors={errors}
              label="Quantidade de Dias"
              placeholder="Qtd."
              formValue="quantidadeDias"
              type="number"
              maxLength={5}
              onChange={(e) => {
                setValue('quantidadeDias', e.target.value)
              }}
            />
            <div />
            <Picker
              defaultValue={DATE_NOW}
              label="Período"
              formValue="periodoInicio"
              control={control}
              onChange={(e) => {
                setValue('periodoInicio', new Date(e.targert.value))
              }}
            />
            <Span text="à" marginTop={SPACING.spacing30} />
            <Picker
              defaultValue={DATE_NOW}
              label="."
              formValue="periodoFim"
              control={control}
              onChange={(e) => {
                setValue('periodoFim', new Date(e.targert.value))
              }}
            />
          </Grid>
          <SimpleCollapse title="INFORMAÇÕES GERAIS">
            <Grid
              gridCols="1fr 1fr"
              gridGap={`0 ${SPACING.spacing30}`}
              margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
            >
              <div>
                <Grid
                  gridCols="1fr 1fr"
                  gridGap={`0 ${SPACING.spacing20}`}
                  margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
                >
                  <AutoCompleteInput
                    name="matriculaContraparte"
                    onChangeText={useDebounce(handleSearchMatricula, 500)}
                    onChange={(
                      selectedMatriculaContraparte,
                      matriculaContraparteValue
                    ) => {
                      setSelectedMatriculaContraparte(
                        selectedMatriculaContraparte || ''
                      )
                      setSelectedContraparte(
                        matriculaContraparteValue?.nmUsuario || ''
                      )
                      setValue(
                        'contraparteId',
                        matriculaContraparteValue?.idUsuarioCsn
                      )
                    }}
                    value={selectedMatriculaContraparte || null}
                    options={autoComplete?.matriculaContraparte || []}
                    noFilter
                    optionValue="label"
                    label="Matricula Contraparte"
                    placeholder="Matricula Contraparte"
                    valueName="value"
                    maxLength={50}
                    marginTop={SPACING.spacing5}
                  />
                  <AutoCompleteInput
                    name="nomeContraparte"
                    onChangeText={useDebounce(handleSearchUsuario, 500)}
                    onChange={(selectedContraparte, contraparteValue) => {
                      setSelectedContraparte(selectedContraparte || '')
                      setSelectedMatriculaContraparte(
                        contraparteValue?.cdMatricula || ''
                      )
                      setValue('contraparteId', contraparteValue?.idUsuarioCsn)
                    }}
                    value={selectedContraparte || null}
                    options={autoComplete?.nomeContraparte || []}
                    noFilter
                    optionValue="label"
                    label="Contraparte"
                    placeholder="Contraparte"
                    valueName="value"
                    maxLength={50}
                    marginTop={SPACING.spacing5}
                  />
                </Grid>
                <Row justifyContent="left" marginBottom={SPACING.spacing10}>
                  <CheckBox
                    checked={
                      contraparteList.length > 0
                        ? isAllContraparteChecked
                        : false
                    }
                    label="Marcar Todos"
                    onChange={() => {
                      handleCheckAllContraparte()
                      setClickCheckAllContraparte(!clickCheckAllContraparte)
                    }}
                  />
                </Row>
                <SimpleCard>
                  <List
                    itemCount={contraparteList?.length}
                    estimatedItemSize={30}
                    itemSize={(index: number) =>
                      getItemSize(contraparteSizeMap, index)
                    }
                    ref={contraparteListRef}
                    height={300}
                    width="100%"
                    useIsScrolling
                  >
                    {({ index, style }) => (
                      <>
                        <div style={style} key={contraparteList[index]?.itemId}>
                          <ReportsRow
                            index={index}
                            windowWidth={windowWidth}
                            setSize={contraparteSetSize}
                          >
                            <CheckBox
                              key={index}
                              checked={contraparteList[index]?.checked}
                              label={contraparteList[index]?.label}
                              onChange={() => {
                                if (contraparteList[index]?.checked) {
                                  handleToWaiveContraparte(
                                    contraparteList[index]
                                  )
                                  return
                                }
                                handleSelectItemContraparte(
                                  contraparteList[index]
                                )
                              }}
                            />
                          </ReportsRow>
                        </div>
                      </>
                    )}
                  </List>
                </SimpleCard>
              </div>
              <div>
                <Grid
                  gridCols="1fr 1fr"
                  gridGap={`0 ${SPACING.spacing20}`}
                  margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
                >
                  <AutoCompleteInput
                    name="matriculaSubstituto"
                    onChangeText={useDebounce(handleSearchMatricula, 500)}
                    onChange={(selectedMatriculaSubstituto, value) => {
                      setSelectedMatriculaSubstituto(
                        selectedMatriculaSubstituto || ''
                      )
                      setSelectedSubstituto(value?.nmUsuario || '')
                      setValue('substitutoId', value?.idUsuarioCsn)
                    }}
                    value={selectedMatriculaSubstituto || null}
                    options={autoComplete?.matriculaSubstituto || []}
                    noFilter
                    optionValue="label"
                    label="Matricula Substituto"
                    placeholder="Matricula Substituto"
                    valueName="value"
                    maxLength={50}
                    marginTop={SPACING.spacing5}
                  />
                  <AutoCompleteInput
                    name="nomeSubstituto"
                    onChangeText={useDebounce(handleSearchUsuario, 500)}
                    onChange={(selectedMatriculaSubstituto, value) => {
                      setSelectedSubstituto(selectedMatriculaSubstituto || '')
                      setSelectedMatriculaSubstituto(value?.cdMatricula || '')
                      setValue('substitutoId', value?.idUsuarioCsn)
                    }}
                    value={selectedSubstituto || null}
                    options={autoComplete?.nomeSubstituto || []}
                    noFilter
                    optionValue="label"
                    label="Substituto"
                    placeholder="Substituto"
                    valueName="value"
                    maxLength={50}
                    marginTop={SPACING.spacing5}
                  />
                </Grid>
                <Row justifyContent="left" marginBottom={SPACING.spacing10}>
                  <CheckBox
                    checked={
                      substitutoList.length > 0 ? isAllSubstitutoChecked : false
                    }
                    label="Marcar Todos"
                    onChange={() => {
                      handleCheckAllSubstituto()
                      setClickCheckAllSubstituto(!clickCheckAllSubstituto)
                    }}
                  />
                </Row>
                <SimpleCard>
                  <List
                    itemCount={substitutoList?.length}
                    estimatedItemSize={30}
                    itemSize={(index: number) =>
                      getItemSize(substitutoSizeMap, index)
                    }
                    ref={substitutoListRef}
                    height={300}
                    width="100%"
                    useIsScrolling
                  >
                    {({ index, style }) => (
                      <>
                        <div style={style} key={substitutoList[index]?.itemId}>
                          <ReportsRow
                            index={index}
                            windowWidth={windowWidth}
                            setSize={substitutoSetSize}
                          >
                            <CheckBox
                              key={index}
                              checked={substitutoList[index]?.checked}
                              label={substitutoList[index]?.label}
                              onChange={() => {
                                if (substitutoList[index]?.checked) {
                                  handleToWaiveSubstituto(substitutoList[index])
                                  return
                                }
                                handleSelectItemSubstituto(
                                  substitutoList[index]
                                )
                              }}
                            />
                          </ReportsRow>
                        </div>
                      </>
                    )}
                  </List>
                </SimpleCard>
              </div>
            </Grid>
            <Grid
              gridCols="1fr 1fr"
              gridGap={`0 ${SPACING.spacing30}`}
              margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
            >
              <div>
                <Grid
                  gridCols="1fr 1fr"
                  gridGap={`0 ${SPACING.spacing20}`}
                  margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
                >
                  <div>
                    <Input
                      onChange={(e) => {
                        setEmpresa(e.target.value)
                      }}
                      label="Empresa"
                      placeholder="Empresa"
                      value={empresa}
                      inputIcon={<MagnifyingGlassIcon />}
                      onClickIcon={() => {
                        handleGetFillCardsAndPrint({})
                      }}
                      marginBottom={SPACING.spacing10}
                    />
                    <Row justifyContent="left" marginBottom={SPACING.spacing10}>
                      <CheckBox
                        checked={
                          empresaList.length > 0 ? isAllEmpresaChecked : false
                        }
                        label="Marcar Todos"
                        onChange={() => {
                          handleCheckAllEmpresa()
                          setClickCheckAllEmpresa(!clickCheckAllEmpresa)
                        }}
                      />
                    </Row>
                    <SimpleCard>
                      <List
                        itemCount={empresaList?.length}
                        estimatedItemSize={30}
                        itemSize={(index: number) =>
                          getItemSize(empresaSizeMap, index)
                        }
                        ref={empresaListRef}
                        height={300}
                        width="100%"
                        useIsScrolling
                      >
                        {({ index, style }) => (
                          <>
                            <div style={style} key={empresaList[index]?.itemId}>
                              <ReportsRow
                                index={index}
                                windowWidth={windowWidth}
                                setSize={empresaSetSize}
                              >
                                <CheckBox
                                  key={index}
                                  checked={empresaList[index]?.checked}
                                  label={empresaList[index]?.label}
                                  onChange={() => {
                                    if (empresaList[index]?.checked) {
                                      handleToWaiveEmpresa(empresaList[index])
                                      return
                                    }
                                    handleSelectItemEmpresa(empresaList[index])
                                  }}
                                />
                              </ReportsRow>
                            </div>
                          </>
                        )}
                      </List>
                    </SimpleCard>
                  </div>
                  <div>
                    <Input
                      onChange={(e) => {
                        setCentro(e.target.value)
                      }}
                      label="Centro"
                      placeholder="Centro"
                      value={centro}
                      inputIcon={<MagnifyingGlassIcon />}
                      onClickIcon={() => {
                        handleGetFillCardsAndPrint({})
                      }}
                      marginBottom={SPACING.spacing10}
                    />
                    <Row justifyContent="left" marginBottom={SPACING.spacing10}>
                      <CheckBox
                        checked={
                          centroList.length > 0 ? isAllCentroChecked : false
                        }
                        label="Marcar Todos"
                        onChange={() => {
                          handleCheckAllCentro()
                          setClickCheckAllCentro(!clickCheckAllCentro)
                        }}
                      />
                    </Row>
                    <SimpleCard>
                      <List
                        itemCount={centroList?.length}
                        estimatedItemSize={30}
                        itemSize={(index: number) =>
                          getItemSize(centroSizeMap, index)
                        }
                        ref={centroListRef}
                        height={300}
                        width="100%"
                        useIsScrolling
                      >
                        {({ index, style }) => (
                          <>
                            <div style={style} key={centroList[index]?.itemId}>
                              <ReportsRow
                                index={index}
                                windowWidth={windowWidth}
                                setSize={centroSetSize}
                              >
                                <CheckBox
                                  key={index}
                                  checked={centroList[index]?.checked}
                                  label={centroList[index]?.label}
                                  onChange={() => {
                                    if (centroList[index]?.checked) {
                                      handleToWaiveCentro(centroList[index])
                                      return
                                    }
                                    handleSelectItemCentro(centroList[index])
                                  }}
                                />
                              </ReportsRow>
                            </div>
                          </>
                        )}
                      </List>
                    </SimpleCard>
                  </div>
                </Grid>
              </div>
              <div>
                <Grid
                  gridCols="1fr 1fr"
                  gridGap={`0 ${SPACING.spacing20}`}
                  margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
                >
                  <Input
                    onChange={(e) => {
                      setFornecedor(e.target.value)
                    }}
                    label="Fornecedor"
                    placeholder="Fornecedor"
                    value={fornecedor}
                    inputIcon={<MagnifyingGlassIcon />}
                    onClickIcon={() => {
                      handleGetFillCardsAndPrint({})
                    }}
                  />
                  <div />
                </Grid>
                <Row justifyContent="left" marginBottom={SPACING.spacing10}>
                  <CheckBox
                    checked={
                      fornecedorList.length > 0 ? isAllFornecedorChecked : false
                    }
                    label="Marcar Todos"
                    onChange={() => {
                      handleCheckAllFornecedor()
                      setClickCheckAllFornecedor(!clickCheckAllFornecedor)
                    }}
                  />
                </Row>
                <SimpleCard>
                  <List
                    itemCount={fornecedorList?.length}
                    estimatedItemSize={30}
                    itemSize={(index: number) =>
                      getItemSize(fornecedorSizeMap, index)
                    }
                    ref={fornecedorListRef}
                    height={300}
                    width="100%"
                    useIsScrolling
                  >
                    {({ index, style }) => (
                      <>
                        <div style={style} key={fornecedorList[index]?.itemId}>
                          <ReportsRow
                            index={index}
                            windowWidth={windowWidth}
                            setSize={fornecedorSetSize}
                          >
                            <CheckBox
                              key={index}
                              checked={fornecedorList[index]?.checked}
                              label={fornecedorList[index]?.label}
                              onChange={() => {
                                if (fornecedorList[index]?.checked) {
                                  handleToWaiveFornecedor(fornecedorList[index])
                                  return
                                }
                                handleSelectItemFornecedor(
                                  fornecedorList[index]
                                )
                              }}
                            />
                          </ReportsRow>
                        </div>
                      </>
                    )}
                  </List>
                </SimpleCard>
              </div>
            </Grid>
            <Grid
              gridCols="1fr 3.2fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
            >
              <Input
                onChange={(e) => {
                  setContrato(e.target.value)
                }}
                label="Contrato"
                placeholder="Contrato"
                value={contrato}
                inputIcon={<MagnifyingGlassIcon />}
                onClickIcon={() => {
                  handleGetFillCardsAndPrint({})
                }}
              />
              <div />
            </Grid>
            <Grid
              gridCols="1fr 1fr"
              gridGap={`0 ${SPACING.spacing30}`}
              margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
            >
              <div>
                <Span text="Subcontratadas do Contrato" />
                <Row justifyContent="left" marginBottom={SPACING.spacing10}>
                  <CheckBox
                    checked={
                      subContratadasContratoList.length > 0
                        ? isAllSubContratadasContratoChecked
                        : false
                    }
                    label="Marcar Todos"
                    onChange={() => {
                      handleCheckAllSubContratadasContrato()
                      setClickCheckAllSubContrato(!clickCheckAllSubContrato)
                    }}
                  />
                </Row>
                <SimpleCard>
                  <List
                    itemCount={subContratadasContratoList?.length}
                    estimatedItemSize={30}
                    itemSize={(index: number) =>
                      getItemSize(subContratadasContratoSizeMap, index)
                    }
                    ref={subContratadasContratoListRef}
                    height={300}
                    width="100%"
                    useIsScrolling
                  >
                    {({ index, style }) => (
                      <>
                        <div
                          style={style}
                          key={subContratadasContratoList[index]?.itemId}
                        >
                          <ReportsRow
                            index={index}
                            windowWidth={windowWidth}
                            setSize={subContratadasContratoSetSize}
                          >
                            <CheckBox
                              key={index}
                              checked={
                                subContratadasContratoList[index]?.checked
                              }
                              label={subContratadasContratoList[index]?.label}
                              onChange={() => {
                                if (
                                  subContratadasContratoList[index]?.checked
                                ) {
                                  handleToWaiveSubContratadasContrato(
                                    subContratadasContratoList[index]
                                  )
                                  return
                                }
                                handleSelectItemSubContratadasContrato(
                                  subContratadasContratoList[index]
                                )
                              }}
                            />
                          </ReportsRow>
                        </div>
                      </>
                    )}
                  </List>
                </SimpleCard>
              </div>
              <div>
                <Span text="Subcontratadas dos Fornecedores" />
                <Row justifyContent="left" marginBottom={SPACING.spacing10}>
                  <CheckBox
                    checked={
                      subContratadasFornecedorList.length > 0
                        ? isAllSubContratadasFornecedorChecked
                        : false
                    }
                    label="Marcar Todos"
                    onChange={() => {
                      handleCheckAllSubContratadasFornecedor()
                      setClickCheckAllSubFornecedor(!clickCheckAllSubFornecedor)
                    }}
                  />
                </Row>
                <SimpleCard>
                  <List
                    itemCount={subContratadasFornecedorList?.length}
                    estimatedItemSize={30}
                    itemSize={(index: number) =>
                      getItemSize(subContratadasFornecedorSizeMap, index)
                    }
                    ref={subContratadasFornecedorListRef}
                    height={300}
                    width="100%"
                    useIsScrolling
                  >
                    {({ index, style }) => (
                      <>
                        <div
                          style={style}
                          key={subContratadasFornecedorList[index]?.itemId}
                        >
                          <ReportsRow
                            index={index}
                            windowWidth={windowWidth}
                            setSize={subContratadasFornecedorSetSize}
                          >
                            <CheckBox
                              key={index}
                              checked={
                                subContratadasFornecedorList[index]?.checked
                              }
                              label={subContratadasFornecedorList[index]?.label}
                              onChange={() => {
                                if (
                                  subContratadasFornecedorList[index]?.checked
                                ) {
                                  handleToWaiveSubContratadasFornecedor(
                                    subContratadasFornecedorList[index]
                                  )
                                  return
                                }
                                handleSelectItemSubContratadasFornecedor(
                                  subContratadasFornecedorList[index]
                                )
                              }}
                            />
                          </ReportsRow>
                        </div>
                      </>
                    )}
                  </List>
                </SimpleCard>
              </div>
            </Grid>
            <Grid gridCols="1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
              <UnidadeGestoraFields
                ref={childRef}
                showInputs={{
                  DiretoriaExecutiva: false,
                  Diretoria: false,
                  Gerencia: true,
                  GerenciaGeral: true
                }}
                gridCols={{
                  Gerencia: 6,
                  GerenciaGeral: 6,
                  spacing: 2
                }}
                onChange={setUnidadeGestoraID}
              />
              <div />
            </Grid>
          </SimpleCollapse>
          <SimpleCollapse title="TIPO DE DOCUMENTO">
            {/* <Grid
              gridCols="1fr 5fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
            >
              <SelectForm
                listOptions={[
                  { label: 'Um', value: '1' },
                  { label: 'Dois', value: '2' }
                ]}
                control={control}
                defaultValue={'1'}
                errors={errors}
                label="Item de Segurança "
                formValue="itemSeguranca"
              />
              <div />
            </Grid> */}
            <Grid
              gridCols="1fr 1fr 1fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
            >
              <div>
                <Row justifyContent="left" marginBottom={SPACING.spacing10}>
                  <CheckBox
                    checked={isAllItemSegurancaChecked}
                    label="Marcar Todos"
                    onChange={() => {
                      handleCheckAllItemSeguranca()
                      setClickCheckAllTipoDocumento(!clickCheckAllTipoDocumento)
                    }}
                  />
                </Row>
                <SimpleCard>
                  <List
                    itemCount={itemSegurancaList?.length}
                    estimatedItemSize={30}
                    itemSize={(index: number) =>
                      getItemSize(itemSegurancaSizeMap, index)
                    }
                    ref={itemSegurancaListRef}
                    height={300}
                    width="100%"
                    useIsScrolling
                  >
                    {({ index, style }) => (
                      <>
                        <div
                          style={style}
                          key={itemSegurancaList[index]?.idItemSeguranca}
                        >
                          <ReportsRow
                            index={index}
                            windowWidth={windowWidth}
                            setSize={itemSegurancaSetSize}
                          >
                            <CheckBox
                              key={index}
                              checked={itemSegurancaList[index]?.checked}
                              label={itemSegurancaList[index]?.nmItemSeguranca}
                              onChange={() => {
                                if (itemSegurancaList[index]?.checked) {
                                  handleToWaiveItemSeguranca(
                                    itemSegurancaList[index]
                                  )
                                  return
                                }
                                handleSelectItemItemSeguranca(
                                  itemSegurancaList[index]
                                )
                              }}
                            />
                          </ReportsRow>
                        </div>
                      </>
                    )}
                  </List>
                </SimpleCard>
              </div>
            </Grid>
          </SimpleCollapse>
          <div style={{ height: SPACING.spacing20 }}></div>
          <Row justifyContent="flex-end">
            <Button
              variantButton="text"
              text="LIMPAR"
              onClick={() => handleClear()}
            />
            <div style={{ width: SPACING.spacing20 }}></div>
            <Button
              variantButton="outlined"
              text="IMPRIMIR"
              onClick={() => {
                handleGetFillCardsAndPrint({
                  isPrint: true
                })
              }}
            />
          </Row>
        </Form>
      </Card>
    </>
  )
}

export default PendingItems
